import { Action } from 'redux';
import { MatchListStoreModel } from '../../utils/match-list-models';
import { DisciplineLiveStatus } from '@om-fe/models';

export const TOURNAMENT_MATCH_AGGREGATOR_PATH: string = 'tournament-aggregator-main/:tournamentId';
export const TOURNAMENT_GROUPS_MATCH_AGGREGATOR_PATH: string = 'tournament-aggregator-groups/:tournamentId';
export const TOURNAMENT_GROUPS_OVERVIEW_MATCH_AGGREGATOR_PATH: string = 'tournament-aggregator-groups-overview/:tournamentId';

export const slicePrefix = 'tournament';

export interface TournamentMatchListStoreModel extends MatchListStoreModel {
    readonly ready: boolean;
    readonly tournamentId?: string;
    readonly liveStatus?: DisciplineLiveStatus;
    readonly isDefault?: boolean;
    readonly mainMarketsLimit?: number;
    readonly groupsLimit?: number;
    readonly marketGroupsOverviewIds?: string;
    readonly isAuthenForTopic?: boolean;
    readonly activeMarketGroup?: Record<string, string>;
    readonly extraParam?: string;
}

export enum TournamentMatchListActions {
    SetFilterData = 'sports:tournament-match-list:set-match-list-filter-data',
    SetActiveMarketGroup = 'sports:tournament-match-list:set-active-market-group',
}

interface TournamentMatchListPayload {
    readonly tournamentId: string;
    readonly liveStatus: DisciplineLiveStatus;
    readonly isDefault?: boolean;
    readonly mainMarketsLimit?: number;
    readonly groupsLimit?: number;
    readonly marketGroupsOverviewIds?: string;
    readonly extraParam?: string;
    readonly isAuthenForTopic?: boolean;
}

interface TournamentMarketGroupPayload {
    readonly activeMarketGroup?: Record<string, string>;
}

interface TournamentParams {
    readonly tournamentId: string;
    readonly liveStatus: DisciplineLiveStatus;
    readonly nrOfMarkets: number;
}

interface TournamentGroupsParams {
    readonly tournamentId: string;
    readonly liveStatus: DisciplineLiveStatus;
    readonly groupsLimit: number;
}

interface TournamentGroupsOverviewParams {
    readonly tournamentId: string;
    readonly liveStatus: DisciplineLiveStatus;
    readonly marketGroupsOverviewIds: string;
    readonly extraParam?: string;
}

export interface TournamentMatchListSetFilterDataAction extends Action<TournamentMatchListActions.SetFilterData> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: TournamentMatchListPayload;
}

export interface TournamentMatchListSetActiveMarketGroupAction extends Action<TournamentMatchListActions.SetActiveMarketGroup> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: TournamentMarketGroupPayload;
}

export interface TournamentMatchListTopic {
    readonly path: string;
    readonly params: TournamentParams;
}

export interface TournamentGroupsMatchListTopic {
    readonly path: string;
    readonly params: TournamentGroupsParams;
}

export interface TournamentGroupsOverviewMatchListTopic {
    readonly path: string;
    readonly params: TournamentGroupsOverviewParams;
}